import { makeStyles, css } from '@conexasaude/conexa-hero'
import { UseStylesProps } from './types'

const useStyles = makeStyles<UseStylesProps>({
  containerLoading: css`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
  `,

  loading: ({ colors }, { useNeutralColor }) => css`
    animation: is-rotating 1s infinite;
    border: 10px solid ${colors.neutral[100]};
    border-radius: 50%;
    border-top-color: ${useNeutralColor
      ? colors.neutral[200]
      : colors.brand.primary[300]};
    height: 100px;
    width: 100px;
    @keyframes is-rotating {
      to {
        transform: rotate(1turn);
      }
    }
  `,

  auxiliaryText: ({ spacing }) => css`
    display: block;
    margin-top: ${spacing.xs};
    text-align: center;
  `,
})

export { useStyles }
